import {Box, CircularProgress} from "@mui/material";

const CircularLoading = ({size, style}: any) => {
   return (
      <Box sx={{display: 'flex'}}>
         <CircularProgress size={size} sx={style} />
      </Box>
   )
}
export default CircularLoading;
